import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import useAxiosPrivate from 'hooks/useAxiosPrivate';

import { SALES_CHANNELS } from 'services/consts';

const initialState = {
	salesChannel: null,
	loading: false,
	error: null
};

export const getOnlineStoreBySlug = createAsyncThunk('onlineStores/fetchBySlug', async (slug, { getState }) => {
	const { salesChannel } = getState();
	if (salesChannel && salesChannel.slug === slug) {
		return salesChannel;
	}

	const axiosPrivate = useAxiosPrivate();
	const response = await axiosPrivate.post(SALES_CHANNELS.GET_SALE_CHANNELS_BY_SLUG, { slug });
	return {
		...response.data,
		ID: response?.data?.id
	};
});

const salesChannel = createSlice({
	name: 'salesChannel',
	initialState,
	reducers: {
		setSalesChannel: (state, { payload }) => ({
			...state,
			salesChannel: payload,
			loading: false
		})
	},
	extraReducers: (builder) => {
		builder
			.addCase(getOnlineStoreBySlug.pending, (state) => ({
				...state,
				loading: true,
				error: null
			}))
			.addCase(getOnlineStoreBySlug.fulfilled, (state, { payload }) => ({
				...state,
				salesChannel: payload,
				loading: false
			}))
			.addCase(getOnlineStoreBySlug.rejected, (state, action) => ({
				...state,
				loading: false,
				error: action.error.message
			}));
	}
});
export const { setSalesChannel } = salesChannel.actions;
export default salesChannel.reducer;
